<template>
  <div class="login">
    <header>
      <img src="../assets/login.png">
      <h1>万丈金数内部管理系统</h1>
    </header>
    <el-form ref="form" status-icon :model="form" :rules="rules" label-width v-show="tab === 'login'">
      <el-form-item label="用户名" prop="user">
        <el-input placeholder="用户名" v-model="form.user" @keyup.13.native="submit('form')"></el-input>
      </el-form-item>
      <el-form-item label="密码" prop="pass">
        <el-input type="password" placeholder="密码" v-model="form.pass" @keyup.13.native="submit('form')"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button :loading="loading" type="primary" @click="submit('form')">登录</el-button>
      </el-form-item>
      <span class="bottom-btn" @click="tab = 'findPwd'">找回密码</span><span class="bottom-btn" @click="tab = 'applyAccount'">账号申请</span>
    </el-form>
    <el-form ref="applyAccount" status-icon :model="applyForm" :rules="applyRules" label-width v-show="tab === 'applyAccount'">
      <el-form-item label="工号" prop="id">
        <el-input placeholder="工号" v-model="applyForm.id" @keyup.13.native="submit('applyAccount')"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input placeholder="姓名" v-model="applyForm.name" @keyup.13.native="submit('applyAccount')"></el-input>
      </el-form-item>
      <el-form-item label="公司邮箱" prop="email">
        <el-input placeholder="公司邮箱" v-model="applyForm.email" @keyup.13.native="submit('applyAccount')"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button :loading="loading" type="primary" @click="submit('applyAccount')">立即申请</el-button>
      </el-form-item>
      <span class="bottom-btn" @click="tab = 'login'">返回登录</span>
    </el-form>
    <el-form ref="findPwd" status-icon :model="findPwd" :rules="findRules" label-width v-show="tab === 'findPwd'">
      <el-form-item label="工号" prop="id">
        <el-input placeholder="工号" v-model="findPwd.id" @keyup.13.native="submit('applyAccount')"></el-input>
      </el-form-item>
      <el-form-item label="姓名" prop="name">
        <el-input placeholder="姓名" v-model="findPwd.name" @keyup.13.native="submit('applyAccount')"></el-input>
      </el-form-item>
      <el-form-item label="公司邮箱" prop="email">
        <el-input placeholder="公司邮箱" v-model="findPwd.email" @keyup.13.native="submit('applyAccount')"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button :loading="loading" type="primary" @click="submit('findPwd')">立即找回</el-button>
      </el-form-item>
      <span class="bottom-btn" @click="tab = 'login'">返回登录</span>
    </el-form>
  </div>
</template>

<script>
import http from '@/plugins/axios'
import * as types from '@/store/mutation-types'
export default {
  data () {
    return {
      loading: false,
      form: {
        user: '',
        pass: ''
      },
      rules: {
        user: { required: true, message: '请输入账号' },
        pass: { required: true, message: '请输入密码' }
      },
      applyForm: {
        id: '',
        name: '',
        email: ''
      },
      applyRules: {
        id: { required: true, message: '请输入工号' },
        name: { required: true, message: '请输入姓名' },
        email: { required: true, message: '请输入公司邮箱' }
      },
      findPwd: {
        id: '',
        name: '',
        email: ''
      },
      findRules: {
        id: { required: true, message: '请输入工号' },
        name: { required: true, message: '请输入姓名' },
        email: { required: true, message: '请输入公司邮箱' }
      },
      tab: 'login'
    }
  },
  methods: {
    submit (formName) {
      this.loading || this.$refs[formName].validate(valid => {
        if (valid) {
          switch (formName) {
            case 'form':
              this.handleLogin()
              break
            case 'applyAccount':
              this.handleApplyAccount()
              break
            case 'findPwd':
              this.handleFindPwd()
              break
          }
        }
      })
    },
    handleLogin() {
      this.loading = true
      this.$store.dispatch('login', this.form).then(res => {
        if (res.successful) {
          let data = res.data
          if (!this.$route.query.redirect) {
            const path = Object.keys(this.$store.state.global.menus)[0] || 'home'
            this.$store.commit(types.RECORD_GLOBAL_PATH, `/${path}`)
            this.$router.push(`/${path}`)
            this.$cookies.set('lyadminInfo', data, {
              path: '/',
              maxAge: 60 * 30
            })
          } else {
            this.$router.push(this.$route.query.redirect)
          }
        } else {
          this.$message.error('密码/账号错误')
        }
      }).finally(() => (this.loading = false))
    },
    handleApplyAccount() {
      this.loading = true
      http.post('/user/add', this.applyForm).then(res => {
        if (res.data.code === 250) {
          this.$alert(`账号申请成功，请到公司邮箱【${this.applyForm.email}】查看邮件。`, '申请提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.tab = 'login'
            }
          })
        }
        this.loading = false
      })
    },
    handleFindPwd() {
      this.loading = true
      http.post('/user/passchange2', this.findPwd).then(res => {
        if (res.data.code === 250) {
          this.$alert(`找回密码成功，请到公司邮箱【${this.findPwd.email}】查看邮件。`, '申请提示', {
            confirmButtonText: '确定',
            callback: action => {
              this.tab = 'login'
            }
          })
        }
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" >
.login {
  width: 400px;
  background-color: #fff;
  border-radius: 4px;
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  .el-input__inner,
  .el-button {
    height: 40px;
  }
  header {
    padding-top: 50px;
    h1 {
      line-height: 30px;
      color: rgba(144, 147, 153, 1);
      font-size: 14px;
      text-align: left;
      text-align: center;
      letter-spacing: 5px;
    }
  }
  .el-form {
    padding: 20px 40px 40px;
  }
  .el-button {
    margin-top: 20px;
    display: block;
    width: 100%;
  }
  input:-webkit-autofill {
    box-shadow: 0 0 0px 1000px #fff inset !important;
  }
  span.bottom-btn {
    font-size: 14px;
    margin: 0 6px;
    float: right;
    text-decoration: underline;
    cursor: pointer;
    color: #fe715b;
  }
}
</style>
